<template>
    <div class="applemember-container" v-if="getUserId==''">
      <div class="applemember-main">
        <div class="applemember-main_ cen">
          <div class="applemember-btn">
            <div class="applemember-btn_" @click="applyMember">
              <div class="normal"></div>
            </div>
          </div>
          <div class="applemember-tip">
            <div class="applemember-tip_">
              <div class="applemember-tip-head">
                <!--成为会员,更多优惠等你来！-->
                <img src="../assets/images/pic01.gif" alt="" width="100%">
              </div>
              <div class="applemember-tip-heads"><span>开通后您可享受</span></div>
            </div>
            <div class="applemember-tip-list">
              <div class="applemember-tip-li leftli"><i class="icon01"></i>在线预约</div>
              <div class="applemember-tip-li centerli"><i class="icon02"></i>服务保障</div>
              <div class="applemember-tip-li rightli"><i class="icon03"></i>会员福利</div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'applyMember',
  computed: {
    ...mapGetters([
      'getUserId'
    ])
  },
  methods: {
    applyMember () {
      let routeUrl = this.$router.resolve({
        path: '/register'
      })
      window.open(routeUrl.href, '_blank')
    }
  }
}
</script>

<style scoped lang="less">
  .applemember-container{
    padding: 20px 0 80px;
  }
  .applemember-main{
    height: 440px;
    background-color: #eb6420;
  }
  .applemember-main_{
    position: relative;
    height: 100%;
  }
  .applemember-btn{
    float: left;
    position: relative;
    left: 0;
    top: 0;
    width: 470px;
    height: 440px;
    background-color: #373334;
    box-shadow: 0px 20px 37.24px 11.76px rgba(37, 37, 37, 0.15);
    .applemember-btn_{
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
      width: 320px;
      height: 80px;
      border-radius: 40px;
      border: 1px solid #eb6420;
      overflow: hidden;
      cursor: pointer;
      transition: all 0.5s ease 0s;
      div{
        width: 100%;
        height: 100%;
        background-image: url("../assets/images/pic03.png");
        background-repeat: no-repeat;
        background-position: center 17px;
      }
      &:hover{
        background-color: #eb6420;
        div{
          background-position: center -53px;
        }
      }
    }
  }
  .applemember-tip{
    overflow: hidden;
    height: 100%;
    .applemember-tip_{
      padding: 0 110px 0 125px;
      .applemember-tip-head{
        padding: 98px 0 0;
        text-align: center;
      }
      .applemember-tip-heads{
        position: relative;
        margin-top: 24px;
        border-bottom: 1px solid #ffffff;
        span{
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%,-50%);
          height: 50px;
          padding: 0 17px;
          background-color: #eb6420;
          font-size: 26px;
          line-height: 50px;
          letter-spacing: 3px;
          color: #ffffff;
          font-weight: 100;
        }
      }
    }
  }
  .applemember-tip-list{
    position: relative;
    margin-top: 92px;
    padding: 0 110px 0 115px;
    overflow: hidden;
    .applemember-tip-li{
      width: 190px;
      margin: 0 auto;
      font-size: 30px;
      line-height: 40px;
      text-align: center;
      color: #fff6c7;
      letter-spacing: 4px;
      &.leftli{
        float: left;
      }
      &.rightli{
        float: right;
      }
      &.centerli{
        position: absolute;
        left: 50%;
        top: 0;
        transform: translateX(-50%);
      }
      i{
        display: inline-block;
        width: 48px;
        height: 40px;
        background-image: url("../assets/images/pic02.gif");
        background-repeat: no-repeat;
        &.icon01{
          background-position: 0 0;
        }
        &.icon02{
          background-position: -103px 0;
        }
        &.icon03{
          background-position: -207px 0;
        }
      }
    }
  }

  @media screen and (max-width: 1480px){
    .applemember-tip{
      .applemember-tip_{
        padding: 0 70px;
      }
    }
    .applemember-tip-list{
      padding: 0 70px;
    }
  }
  @media screen and (max-width: 1380px){
    .applemember-tip{
      .applemember-tip_{
        padding: 0 30px;
      }
    }
    .applemember-tip-list{
      padding: 0 30px;
    }
  }
  @media screen and (max-width: 1200px){
    .applemember-container{
      padding: 10px 0 40px;
    }
    .applemember-main{
      height: auto;
    }
    .applemember-btn{
      float: none;
      top: 0;
      width: 100%;
      height: 220px;
      .applemember-btn_{
        width: 160px;
        height: 40px;
        border-radius: 20px;
        div{
          background-size: 97px auto;
          background-position: center 8px;
        }
        &:hover{
          div{
            background-position: center -26px;
          }
        }
      }
    }
    .applemember-tip{
      .applemember-tip_{
        padding: 0;
        .applemember-tip-head{
          padding: 49px 0 0;
        }
        .applemember-tip-heads{
          margin-top: 12px;
          span{
            height: 25px;
            padding: 0 10px;
            font-size: 15px;
            line-height: 25px;
            letter-spacing: 3px;
          }
        }
      }
    }
    .applemember-tip-list{
      margin-top: 46px;
      .applemember-tip-li{
        width: 100%;
        margin-bottom: 20px;
        font-size: 15px;
        &.leftli{
          float: none;
        }
        &.rightli{
          float: none;
        }
        &.centerli{
          position: relative;
          left: 0;
          top: 0;
          transform: none;
        }
      }
    }
  }
</style>
